const ruBreadcrumbsMapper = path => urls[path];

const urls = {
    '/monitoring/insurance': [
        {ru: 'monitoring.breadcrumbs.monitoring', link: ''},
        {ru: 'monitoring.breadcrumbs.insuranceMonitoring', link: ''}
    ],
};

export default ruBreadcrumbsMapper;